import { FiGithub, FiLinkedin } from "react-icons/fi";
import {
  EmailText,
  IconNames,
  IconTextWrapper,
  IconsWrapper,
  LeftSocialBar,
  RightSocialBar,
  SocialsWrapper,
  VerticalLineLeft,
  VerticalLineRight,
} from "./Socials.styled";

export const Socials = () => {
  return (
    <>
      <SocialsWrapper className="SocialsWrapper">
        <LeftSocialBar
          className="LeftSocialBar"
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // transition={{ duration: 2 }}
          initial={{ y: 300 }}
          animate={{ y: 0 }}
          transition={{ duration: 1 }}
        >
          <IconsWrapper>
            <a href="https://github.com/VasilHT">
              <IconTextWrapper>
                <FiGithub style={{ height: "20px", width: "20px" }} />
                <IconNames>Github</IconNames>
              </IconTextWrapper>
            </a>
            <a href="https://www.linkedin.com/in/vasilht/">
              <IconTextWrapper>
                <FiLinkedin style={{ height: "20px", width: "20px" }} />
                <IconNames>Linkedin</IconNames>
              </IconTextWrapper>
            </a>
          </IconsWrapper>
          <VerticalLineLeft />
        </LeftSocialBar>
      </SocialsWrapper>
      <SocialsWrapper>
        <RightSocialBar
          className="RightSocialBar"
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // transition={{ duration: 2 }}
          initial={{ y: 300 }}
          animate={{ y: 0 }}
          transition={{ duration: 1 }}
        >
          <EmailText>vasil.htosev@gmail.com</EmailText>
          <VerticalLineRight />
        </RightSocialBar>
      </SocialsWrapper>
    </>
  );
};
